import ExpandMore from "@mui/icons-material/ExpandMore";
import { Button, Menu, MenuItem, MenuList } from "@mui/material";
import { WasteManifestImporter } from "components/WasteManifestImporter";
import { OneSchemaTemplateType } from "encamp-shared/src/oneSchema/types";
import { ProcessingFunction } from "generated-graphql/graphql";
import { useState } from "react";
export const StaffManifestActionsMenu = function () {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const buttonId = "staff-bulk-actions-button";

  return (
    <>
      <Button
        id={buttonId}
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        variant="contained"
        onClick={handleClick}
        endIcon={<ExpandMore />}
      >
        Staff
      </Button>
      <Menu
        id="staff-bulk-actions-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": buttonId,
        }}
      >
        <MenuList dense>
          <MenuItem key="import-vendor">
            <WasteManifestImporter
              templateType={OneSchemaTemplateType.OtherWasteManifest}
              label="Import Vendor"
              refetchQueries={["WasteManifests"]}
              style={{ justifyContent: "flex-start", width: "100%" }}
              processingFunction={ProcessingFunction.WasteManifest}
            />
          </MenuItem>
          <MenuItem key="import-eManifest">
            <WasteManifestImporter
              templateType={OneSchemaTemplateType.eManifest}
              label="Import e‑Manifest"
              refetchQueries={["WasteManifests"]}
              style={{ justifyContent: "flex-start", width: "100%" }}
              processingFunction={ProcessingFunction.EManifest}
            />
          </MenuItem>
        </MenuList>
      </Menu>
    </>
  );
};
